import { ActionPlanAction } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetOneActionPlanAction";
import { SsqProperty } from "src/api/sure-api/actions/useGetOneAction";

type ActionFieldsProperties = {
    pivot: SsqProperty | null;
    properties: SsqProperty[];
};

const EMPTY_PROPERTIES = {
    pivot: null,
    properties: [],
};

export const getSubpropertiesFromPropertyTree = (
    actionPlanAction: ActionPlanAction | undefined,
): ActionFieldsProperties => {
    const action = actionPlanAction?.action;

    if (action === undefined) return EMPTY_PROPERTIES;

    const propertiesTree = action.propertiesTree;

    if (propertiesTree === undefined) return EMPTY_PROPERTIES;

    const subproperties = Object.entries(propertiesTree).flatMap(([propertyId, subpropertiesIds]) => {
        const property = action.ssqProperties.find((property) => property.id === parseInt(propertyId));

        if (property === undefined) return [];

        return property.children?.filter((subproperty) => subpropertiesIds.includes(subproperty.id)) ?? [];
    });

    if (subproperties.length === 0) {
        return EMPTY_PROPERTIES;
    }

    const pivot = subproperties[0];
    return {
        pivot,
        properties: subproperties,
    };
};
